import { render, staticRenderFns } from "./ChooseAddress.vue?vue&type=template&id=043ffa64&scoped=true&"
import script from "./ChooseAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseAddress.vue?vue&type=script&lang=js&"
import style1 from "./ChooseAddress.vue?vue&type=style&index=1&id=043ffa64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ffa64",
  null
  
)

export default component.exports